import { jsx } from "react/jsx-runtime";
import { DeleteFilled } from "@wepie/weet-icons";
const overrideAllowClearProp = (allowClearProp)=>{
    if (true === allowClearProp || void 0 === allowClearProp) return {
        clearIcon: /*#__PURE__*/ jsx(DeleteFilled, {})
    };
    return allowClearProp;
};
const defaultShowTotal = {
    formatter: ({ count, maxLength })=>maxLength ? `${count}/${maxLength}` : `${count}`
};
const overrideShowCountProp = (showCountProp)=>{
    if (!showCountProp) return false;
    if (true === showCountProp) return defaultShowTotal;
    return showCountProp;
};
const overrideCountProp = (countProp)=>{
    if (!countProp) return;
    return {
        ...countProp,
        show: countProp.show && defaultShowTotal.formatter
    };
};
export { overrideAllowClearProp, overrideCountProp, overrideShowCountProp };
